/* ==========================================================================
   <trichtr-review-form> — eigenes Review-Formular, postet direkt an Judge.me.
   - Toggle: der externe Button [data-review-form-toggle="<id>"] klappt es auf/zu.
   - Sterne-Input (Radiogroup), Client-Validierung, Honeypot gegen Bots.
   - POST an Judge.mes öffentlichen Review-Endpoint (kein geheimer Token nötig;
     require_verification_before_submit ist im Store aus). Review landet als
     "pending" zur Moderation.
   Daten kommen per data-* vom Section-Markup.
   ========================================================================== */
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  class TrichtrReviewForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.msg = this.querySelector('[data-msg]');
      this.submitBtn = this.querySelector('[data-submit]');
      this.endpoint = this.dataset.endpoint;
      this.shopDomain = this.dataset.shopDomain;
      this.productId = this.dataset.productId;
      this.productUrl = this.dataset.productUrl;
      this.successText = this.dataset.successText || 'Danke! Deine Bewertung wird nach Prüfung veröffentlicht.';
      this.errorText = this.dataset.errorText || 'Da ist etwas schiefgelaufen. Bitte versuch es später erneut.';

      this.toggles = Array.prototype.slice.call(
        document.querySelectorAll('[data-review-form-toggle="' + this.id + '"]')
      );
      this.toggles.forEach((btn) => {
        btn.addEventListener('click', (e) => { e.preventDefault(); this.toggleOpen(); });
      });

      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    toggleOpen(force) {
      var open = force !== undefined ? force : !this.classList.contains('is-open');
      this.classList.toggle('is-open', open);
      this.toggles.forEach((b) => b.setAttribute('aria-expanded', String(open)));
      if (open) {
        var first = this.querySelector('input[name="name"]');
        window.setTimeout(() => { try { first && first.focus(); } catch (e) {} }, 60);
      }
    }

    setFieldError(name, show) {
      var el = this.querySelector('[data-error-for="' + name + '"]');
      if (el) el.hidden = !show;
      var input = this.form.elements[name];
      if (input && input.setAttribute && name !== 'rating') {
        input.setAttribute('aria-invalid', show ? 'true' : 'false');
      }
    }

    collect() {
      var f = this.form.elements;
      var ratingEl = this.form.querySelector('input[name="rating"]:checked');
      return {
        rating: ratingEl ? ratingEl.value : '',
        name: (f['name'].value || '').trim(),
        email: (f['email'].value || '').trim(),
        title: (f['title'].value || '').trim(),
        body: (f['body'].value || '').trim(),
        hp: f['jdgm_hp'] ? f['jdgm_hp'].value : ''
      };
    }

    validate(d) {
      var ok = true;
      var checks = {
        rating: !!d.rating,
        name: d.name.length > 0,
        email: EMAIL_RE.test(d.email),
        title: d.title.length > 0,
        body: d.body.length > 0
      };
      Object.keys(checks).forEach((k) => {
        this.setFieldError(k, !checks[k]);
        if (!checks[k]) ok = false;
      });
      if (!ok) {
        var firstBad = this.querySelector('[data-error-for]:not([hidden])');
        if (firstBad) firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return ok;
    }

    setLoading(on) {
      if (!this.submitBtn) return;
      this.submitBtn.disabled = on;
      var label = this.submitBtn.querySelector('span');
      if (label) {
        if (on) { this._label = label.textContent; label.textContent = 'Wird gesendet…'; }
        else if (this._label) { label.textContent = this._label; }
      }
    }

    show(kind, text) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.classList.toggle('review-form__msg--success', kind === 'success');
      this.msg.classList.toggle('review-form__msg--error', kind === 'error');
      this.msg.hidden = false;
    }
    clearMsg() { if (this.msg) this.msg.hidden = true; }

    async onSubmit(e) {
      e.preventDefault();
      this.clearMsg();
      var d = this.collect();

      // Honeypot: von Bots ausgefüllt -> stilles OK, nichts senden.
      if (d.hp) { this.finishSuccess(); return; }
      if (!this.validate(d)) return;

      this.setLoading(true);
      try {
        var body = new URLSearchParams();
        body.set('shop_domain', this.shopDomain);
        body.set('platform', 'shopify');
        body.set('id', this.productId);
        if (this.productUrl) body.set('url', this.productUrl);
        body.set('name', d.name);
        body.set('email', d.email);
        body.set('rating', d.rating);
        body.set('title', d.title);
        body.set('body', d.body);

        var res = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body: body.toString()
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        this.finishSuccess();
      } catch (err) {
        this.show('error', this.errorText);
      } finally {
        this.setLoading(false);
      }
    }

    finishSuccess() {
      // Formularfelder ausblenden, Erfolgsmeldung zeigen.
      Array.prototype.forEach.call(
        this.form.querySelectorAll('.review-form__field, .review-form__row, .review-form__submit, .review-form__note'),
        (el) => { el.style.display = 'none'; }
      );
      this.show('success', this.successText);
      try { this.form.reset(); } catch (e) {}
    }
  }

  if (!customElements.get('trichtr-review-form')) {
    customElements.define('trichtr-review-form', TrichtrReviewForm);
  }
})();
